import { styled } from "@mui/material";
import Box from "@mui/material/Box";

export const StyledEntityName = styled(Box)`
  ${({ theme }) => theme.wsc.typography.body1};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%; // Add this to ensure text truncation works
`;

export const StyledVerticalGroup = styled(Box)`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr auto;
  width: 100%;
`;

export const StyledEntityGroup = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.wsc.spacing[1]};
  max-width: 90%;
  overflow: hidden; // Add this to contain the entity names
`;

export const StyledEntityContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.wsc.spacing[1]};
  overflow: hidden; // Add this to prevent overflow
`;

export const StyledGroupScore = styled(Box)`
  ${({ theme }) => theme.wsc.typography.body2};
  display: flex;
  gap: ${({ theme }) => theme.wsc.spacing[1]};
  justify-content: center;
  flex-shrink: 0; // Add this to prevent score from shrinking
  margin-left: auto; // Push to the right
`;
